<ng-container *ngrxLet="templateService.currentMode$ as currentMode">
  <header
    id="header"
    class="primary-background"
    [attr.current-mode]="currentMode"
    style="width: 100%"
  >
    <div id="logo">
      <a href="javascript:void(0)" (click)="navigateHomeWithCacheRefresh()"
        >DUNA</a
      >
    </div>
    <nav>
      <div
        class="burger-menu"
        [class.active]="isMenuOpen"
        (click)="toggleMenu(); $event.stopPropagation()"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul class="nav-menu nav-menu--desktop">
        <ng-container *ngTemplateOutlet="navLinks"></ng-container>
      </ul>
    </nav>
  </header>
</ng-container>

<div
  #mobileNav
  class="duna-mobile-nav"
  [class.open]="isMenuOpen"
  (click)="closeMenuOnMobile()"
>
  <ul class="nav-menu nav-menu--mobile" (click)="$event.stopPropagation()">
    <ng-container *ngTemplateOutlet="navLinks"></ng-container>
  </ul>
</div>

<ng-template #navLinks>
  <ng-container *ngrxLet="currentPortal$ as currentPortal">
    @if (currentPortal === 'administration') {
    <li>
      <a
        routerLink="/dashboard"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Dashboard</a
      >
    </li>
    <li>
      <a
        routerLink="/ressourcer"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Ressourcer</a
      >
    </li>
    <li>
      <a
        routerLink="/lokationer"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Lokationer</a
      >
    </li>
    <li>
      <a
        routerLink="/brugere"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Brugere</a
      >
    </li>
    <li>
      <a
        routerLink="/events"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Kalender</a
      >
    </li>
    <li>
      <a
        routerLink="/indstillinger"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Indstillinger</a
      >
    </li>
    } @if (currentPortal === 'user') {
    <ng-container *ngrxLet="hasUddansvarligRole$ as hasUddansvarligRole">
      @if (hasUddansvarligRole) {
      <li>
        <a
          routerLink="/dashboard"
          routerLinkActive="activebutton"
          ariaCurrentWhenActive="page"
          (click)="closeMenuOnMobile()"
          >Dashboard</a
        >
      </li>
      }
    </ng-container>
    <li>
      <a
        routerLink="/profile"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Profil</a
      >
    </li>
    <li>
      <a
        routerLink="/mine_stationer"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Mine Stationer</a
      >
    </li>
    <li>
      <a
        routerLink="/events"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Kalender</a
      >
    </li>
    <li>
      <a
        routerLink="/indstillinger"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Indstillinger</a
      >
    </li>
    } @if (currentPortal === 'external') {
    <li>
      <a
        routerLink="/profile"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Profil</a
      >
    </li>
    <li>
      <a
        routerLink="/events"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Kalender</a
      >
    </li>
    <li>
      <a
        routerLink="/indstillinger"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Indstillinger</a
      >
    </li>
    } @if (currentPortal === null) {
    <li>
      <a
        routerLink="/"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Forside</a
      >
    </li>
    <li>
      <a
        routerLink="/events"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Kalender</a
      >
    </li>
    <li>
      <a
        routerLink="/kontakt"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Kontakt</a
      >
    </li>
    <li>
      <a
        routerLink="/faq"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >FAQ</a
      >
    </li>
    }
  </ng-container>
  <ng-container *ngrxLet="isAuthenticated$ as isAuthenticated">
    @if (!isAuthenticated) {
    <li>
      <a
        routerLink="/login"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        (click)="closeMenuOnMobile()"
        >Log ind</a
      >
    </li>
    } @else {
    <li><a class="logout-button" (click)="logout()">Log ud</a></li>
    <ng-container
      *ngrxLet="hasMultipleAccountTypes$ as hasMultipleAccountTypes"
    >
      @if (hasMultipleAccountTypes) {
      <li class="account-switcher">
        <a (click)="openAccountTypeSwitcher(); closeMenuOnMobile()">
          <mat-icon>admin_panel_settings</mat-icon>
        </a>
      </li>
      }
    </ng-container>
    }
  </ng-container>
</ng-template>
